import MetricStats from '~/modules/metric-stats/component/MetricStats';
import type { ProductProfessional } from '../../type/product-professional';

type StatsProf = Pick<
    ProductProfessional,
    | 'EnquiryResponseRate'
    | 'ProductCount'
    | 'URLSegment'
    | 'EnquiryAvgResponseHours'
>;
interface StatsProps {
    data: StatsProf;
}

const getMetricData = (data: StatsProf) => {
    const profilePage = `/professional/${data.URLSegment}`;
    const productCount = String(data.ProductCount);

    return {
        productCount,
        profilePage,
    };
};

const Stats = ({ data }: StatsProps) => {
    const { productCount, profilePage } = getMetricData(data);

    return (
        <MetricStats
            stats={[
                {
                    label: 'Products listed',
                    link: `${profilePage}/our-products`,
                    testID: 'product-count',
                    data: productCount,
                },
            ]}
        />
    );
};

export default Stats;
